"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDynamicCodeResetTradePwdRequest = void 0;
var GetDynamicCodeResetTradePwdRequest = /** @class */ (function () {
    function GetDynamicCodeResetTradePwdRequest() {
    }
    return GetDynamicCodeResetTradePwdRequest;
}());
exports.GetDynamicCodeResetTradePwdRequest = GetDynamicCodeResetTradePwdRequest;
;
//# sourceMappingURL=getDynamicCodeResetTradePwd.request.js.map